import type { ComponentType } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Redirect } from '../../router/react-router-v5-compat';
import { HookDecorator } from '../main/main-page-states';
import MenuDishMakerComponent from './menu-dish-maker-page.component';
import ExtraCostComponent from './extra-cost/extra-cost.component';
import CondimentGroupComponent from './condiments/condiment-group.component';
import DishSoldOutSetting from './dish-sold-out/dish-sold-out.component';
import PriceSpecificationComponent from './price-specification/price-specification.component';
import DishReportLabel from './dish-report-label/dish-report-label.page';
import DishPostLabel from './dish-post-label/dish-post-label.page';
import QuickOrderRemarks from './quick-order-remarks/quick-order-remarks.page';
/** 云 RBP「菜单菜品」路由前缀；侧栏子项 path 均在此下 */
export const DISH_MENU_BASE = '/main/rbp-cloud/dish-menu';

/** 默认子页：菜单菜品制作器 */
const DISH_MENU_CREATOR_PATH = `${DISH_MENU_BASE}/creator`;

const TAB_DEFS: {
    /** 完整应用路径 */
    path: string;
    /** 子页组件 */
    Component: ComponentType;
}[] = [
    { path: DISH_MENU_CREATOR_PATH, Component: MenuDishMakerComponent },
    { path: `${DISH_MENU_BASE}/extra-cost`, Component: ExtraCostComponent },
    { path: `${DISH_MENU_BASE}/condiment`, Component: CondimentGroupComponent },
    { path: `${DISH_MENU_BASE}/sold-out`, Component: DishSoldOutSetting },
    { path: `${DISH_MENU_BASE}/standard`, Component: PriceSpecificationComponent },
    { path: `${DISH_MENU_BASE}/report-type`, Component: DishReportLabel },
    { path: `${DISH_MENU_BASE}/job`, Component: DishPostLabel },
    { path: `${DISH_MENU_BASE}/remarks`, Component: QuickOrderRemarks },
];

/**
 * 云 RBP「菜单菜品」壳页：侧栏切换子 path 时仅替换内容区，隧道校验由全局 `tunnelStatusStore` + 父级 `HookDecorator` 负责，避免每 Tab 重复 `check-permission`。
 */
const DishMenuShellPage = HookDecorator(function DishMenuShellPageInner() {
    const { pathname } = useLocation();

    if (pathname === DISH_MENU_BASE || pathname === `${DISH_MENU_BASE}/`) {
        return <Redirect to={DISH_MENU_CREATOR_PATH} />;
    }

    const active = TAB_DEFS.find((t) => t.path === pathname);
    if (!active) {
        return <Redirect to={DISH_MENU_CREATOR_PATH} />;
    }

    const { Component } = active;

    return (
        <Box className="dish-menu-shell-page" sx={{ width: '100%' }}>
            <Component />
        </Box>
    );
});

export default DishMenuShellPage;
